module.exports = __webpack_public_path__ + "img/association-institution-1.0322d7df.png";